module.exports = new __parcel__URL__("folder.025da90c.svg").toString();